import { SurveyType } from "../../enums";

export class SurveyPostRequest {
    surveyType: SurveyType;
    questionNum: number = 0;
    answerId: number = 0;
}